import type { ReactNode } from 'react'

/** §3: white surface, rounded-lg, border, subtle shadow. */
export function Card({
  title,
  subtitle,
  action,
  children,
  className = '',
}: {
  title?: string
  /** One line under the title, for a card whose purpose needs a sentence rather than a label. */
  subtitle?: string
  action?: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <section
      className={`rounded-lg border border-dpl-border bg-dpl-surface shadow-sm ${className}`}
    >
      {(title || action) && (
        <header className="flex flex-wrap items-start justify-between gap-2 border-b border-dpl-border px-4 py-3.5 sm:px-5">
          {title && (
            // Title and subtitle share a column so the action stays on the header's own line, at
            // the top, rather than being pushed down by a long sentence.
            <div className="min-w-0">
              <h2 className="text-xs font-semibold uppercase tracking-wide text-dpl-muted">
                {title}
              </h2>
              {subtitle && <p className="mt-1 text-sm text-dpl-muted">{subtitle}</p>}
            </div>
          )}
          {action}
        </header>
      )}
      <div className="p-4 sm:p-5">{children}</div>
    </section>
  )
}
